export default __webpack_public_path__ + "static/media/yourspace-min.f952e744.png";